// Example in a Footer component
import { Link } from "react-router-dom";

const Footer = () => (
  <footer className="text-center p-4 bg-slate-800 text-gray-400 text-sm">
    © {new Date().getFullYear()} Practap. All rights reserved.
    <div className="mt-2">
      <Link to="/privacy-policy" className="hover:text-white mx-2">
        Privacy Policy
      </Link>
      |
      <Link to="/terms-of-service" className="hover:text-white mx-2">
        Terms of Service
      </Link>
    </div>
  </footer>
);
// Then include <Footer /> in your App.js or layout component.
export default Footer;
